import type { DeeplinkView } from './DeeplinkView';
import { OpxDeeplinkRoute, ROUTE_TO_VIEW_DEFINITIONS_OPXDEEPLINK } from 'owa-opx-routes';

export const READ_ROUTE = 'read';
export const COMPOSE_ROUTE = 'compose';

export type DeeplinkRoute = typeof READ_ROUTE | typeof COMPOSE_ROUTE | OpxDeeplinkRoute;

type RouteToViewDefinitions = { [route in DeeplinkRoute]: DeeplinkView };

export const ROUTE_TO_VIEW_DEFINITIONS: RouteToViewDefinitions = {
    [READ_ROUTE]: 'Read',
    [COMPOSE_ROUTE]: 'Compose',
    ...ROUTE_TO_VIEW_DEFINITIONS_OPXDEEPLINK,
};
